<script setup lang="ts">
import type {Goal} from '@/ts/types/dto/interventions-dto';
import {useI18n} from 'vue-i18n';
import InterventionLandingGoal from '@/vue/organisms/intervention-landing/intervention-landing-goal.vue';
import {useDragToScroll} from '@/ts/composables/pure/use-drag-to-scroll';

const {t: $t} = useI18n();

defineProps<{ goals: Goal[] }>();

const {scrollAreaRef, onMouseDown} = useDragToScroll();
</script>

<template>
  <div class="intervention-landing-goals">
    <h3 class="title">
      {{ $t('path_goals') }}
    </h3>
    <q-scroll-area ref="scrollAreaRef" class="goals-scroll-area" style="max-width: 100%;">
      <div
        class="goals goals-grab"
        @mousedown="onMouseDown"
      >
        <div v-for="(goal, index) in goals" :key="goal.id" class="goal">
          <intervention-landing-goal :goal="goal" :order="index + 1"/>
        </div>
      </div>
    </q-scroll-area>
  </div>
</template>

<style scoped lang="scss">
.intervention-landing-goals {
  padding-bottom: var(--Spacing-spacing-8);
}

.title {
  @include font-h3-bold;
  margin-bottom: var(--Spacing-spacing-5)
}

.goals-scroll-area {
  height: calc(300px + var(--Spacing-spacing-5) + var(--Spacing-spacing-1));

  @include screen-md {
    height: calc(400px + var(--Spacing-spacing-5));
  }
}

.goals {
  display: flex;
  align-items: stretch;
  gap: var(--Spacing-spacing-3);
  padding: 6px 0;
  padding-right: var(--Spacing-spacing-6);

  .goal {
    flex-shrink: 0;
  }
}

.goals-grab {
  cursor: grab;
  user-select: none;
}
</style>
